
import ArrangeSquare from "../../../assets/duotone/ArrangeSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ArrangeSquareIcon({ className, dataTestid = "ArrangeSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ArrangeSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
